"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useBalances = require("./useBalances");
Object.keys(_useBalances).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useBalances[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useBalances[key];
    }
  });
});
var _useBalancesWithTotal = require("./useBalancesWithTotal");
Object.keys(_useBalancesWithTotal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useBalancesWithTotal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useBalancesWithTotal[key];
    }
  });
});